import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Center,
  Spinner
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

type NecesidadeAtuacao = {
  codTipoPublicacao: number;
  seqConteudo: number;
  codPendencia: number;
  pendenciaDTO: any;
  conteudoDTO: any;
  nomeavisos: string;
  datRegistro: string;
  solicitante: number;
  codRede?: number;
};

interface TabelaAvisoPublicacoesRejeitadasProps {
  listaAvisoPublicacoesRejeitadas: NecesidadeAtuacao[];
  listaVazia: string;
  loading: boolean;
}

const TabelaAvisoPublicacoesRejeitadas = ({
  listaAvisoPublicacoesRejeitadas,
  listaVazia,
  loading,
}: TabelaAvisoPublicacoesRejeitadasProps) => {
  const navigate = useNavigate();

  const handleRowClick = (
    codTipoPublicacao: number,
    seqConteudo: number,
    codRede?: number
  ) => {
    if (codTipoPublicacao === 1 && seqConteudo) {
      navigate(`/cms/publicacao/noticia/editar-noticia/${seqConteudo}`)
    }
    if (codTipoPublicacao === 2 && seqConteudo) {
      navigate(`/cms/publicacao/evento/editar-evento/${seqConteudo}`)
    }
    if (codTipoPublicacao === 3 && seqConteudo) {
      navigate(`/cms/publicacao/banner/editar-banner/${seqConteudo}`)
    }
    if (codTipoPublicacao === 5 && seqConteudo) {
      navigate(`/cms/publicacao/imprensa-oficial/editar-imprensa-oficial/${seqConteudo}`)
    }
    if (codTipoPublicacao === 6 && seqConteudo) {
      navigate(
        `/cms/publicacao/redes-sociais/publicacoes/${codRede ?? ''}/editar-rede-social/${seqConteudo}`
      )
    }
  }

  const renderRows = () => {
    return listaAvisoPublicacoesRejeitadas.length > 0 ? (
      listaAvisoPublicacoesRejeitadas.map((avisos) => (
        <Tr
          key={avisos.seqConteudo}
          cursor="pointer"
          onClick={() =>
            handleRowClick(
              avisos.codTipoPublicacao,
              avisos.seqConteudo,
              avisos.codTipoPublicacao === 6 ? avisos.codRede : undefined
            )
          }
        >
          <Td>
            {avisos.codTipoPublicacao === 1
              ? 'Notícia'
              : avisos.codTipoPublicacao === 2
              ? 'Evento'
              : avisos.codTipoPublicacao === 3
              ? 'Banner'
              : avisos.codTipoPublicacao === 5
              ? 'Imprensa Oficial'
              : avisos.codTipoPublicacao === 6
              ? 'Rede Social'
              : ''}
          </Td>
          <Td>{avisos.pendenciaDTO.dscDomPendencia}</Td>
          <Td>{avisos.datRegistro.split('-').reverse().join('/')}</Td>
          <Td>{avisos.solicitante}</Td>
        </Tr>
      ))
    ) : (
      <Tr>
        <Td colSpan={5} color="#999898" textAlign="center">
          {listaVazia}
        </Td>
      </Tr>
    );
  };

  return (
    <TableContainer>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Recurso</Th>
            <Th>Pendência</Th>
            <Th>Data da Solicitação</Th>
            <Th>Solicitante</Th>
          </Tr>
        </Thead>
        <Tbody>
          {loading ? (
            <Tr>
              <Td colSpan={5}>
                <Center>
                  <Spinner size="lg" color="blue.500" />
                </Center>
              </Td>
            </Tr>
          ) : (
            renderRows()
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default TabelaAvisoPublicacoesRejeitadas;
